import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className=' footer-container'>
            <div className="footer-parent">
                <img className='w-screen ' src={require ('../../../img/shape-bg.png')} alt='no internet'/>
            </div>
            
        </div>
    );
};

export default Footer;